<template>
  <div>
      <TimeTable
      />
  </div>
</template>

<script>
// @ is an alias to /src
import TimeTable from '@/components/TimeTable.vue'

export default {
  name: 'ProjectRegistrations',
  components: {
    TimeTable
  }
}
</script>
